"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.classes = void 0;
const Button_1 = __importDefault(require("@mui/material/Button"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "Button";
exports.classes = {
    root: `${PREFIX}-root`,
    text: `${PREFIX}-text`,
    contained: `${PREFIX}-contained`,
    startIcon: `${PREFIX}-startIcon`,
    textDarkBg: `${PREFIX}-textDarkBg`,
    outlinedDarkBg: `${PREFIX}-outlinedDarkBg`,
    opaqueOutlined: `${PREFIX}-opaqueOutlined`,
    opaqueOutlinedDarkBg: `${PREFIX}-opaqueOutlinedDarkBg`,
    containedDarkBg: `${PREFIX}-containedDarkBg`
};
exports.StyledButton = (0, styles_1.styled)(Button_1.default)(({ theme: { colours, palette } }) => ({
    [`&.${exports.classes.root}`]: {
        fontSize: "1rem",
        borderRadius: 3,
        overflowWrap: "anywhere"
    },
    [`&.${exports.classes.text}`]: {
        "&:hover": {
            backgroundColor: (0, styles_1.alpha)(colours.black, 0.05)
        }
    },
    [`&.${exports.classes.contained}`]: {
        "&.Mui-disabled": {
            backgroundColor: (0, styles_1.alpha)(palette.primary.main, 0.38),
            color: colours.white
        }
    },
    [`&.${exports.classes.startIcon}`]: {
        marginLeft: 0
    },
    // custom classes
    [`&.${exports.classes.textDarkBg}`]: {
        color: (0, styles_1.alpha)(colours.white, 0.8),
        "&:hover": {
            color: colours.white,
            backgroundColor: (0, styles_1.alpha)(colours.white, 0.1),
            transition: "color 0.35s ease-in-out"
        },
        "&.Mui-disabled": {
            color: (0, styles_1.alpha)(colours.white, 0.38)
        }
    },
    [`&.${exports.classes.outlinedDarkBg}`]: {
        color: colours.white,
        borderColor: (0, styles_1.alpha)(colours.white, 0.8),
        backgroundColor: (0, styles_1.alpha)(colours.white, 0.1),
        "&:hover": {
            borderColor: colours.white,
            backgroundColor: "transparent"
        },
        "&.Mui-disabled": {
            color: (0, styles_1.alpha)(colours.white, 0.3),
            backgroundColor: (0, styles_1.alpha)(colours.white, 0.2),
            borderColor: (0, styles_1.alpha)(colours.white, 0.3)
        }
    },
    [`&.${exports.classes.opaqueOutlined}`]: {
        backgroundColor: colours.white,
        position: "relative",
        "&:hover": {
            backgroundColor: colours.white,
            position: "relative",
            "&::after": {
                content: "''",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: (0, styles_1.alpha)(colours.focus, 0.04)
            }
        },
        "&.Mui-disabled": {
            backgroundColor: colours.white
        }
    },
    [`&.${exports.classes.opaqueOutlinedDarkBg}`]: {
        color: palette.primary.dark,
        borderColor: (0, styles_1.alpha)(colours.interDark, 0.5),
        "&:hover": {
            borderColor: colours.interDark,
            "&::after": {
                backgroundColor: (0, styles_1.alpha)(colours.interDark, 0.04)
            }
        }
    },
    [`&.${exports.classes.containedDarkBg}`]: {
        backgroundColor: colours.interDark,
        "&:hover": {
            backgroundColor: colours.focusDark
        },
        "&.Mui-disabled": {
            backgroundColor: (0, styles_1.alpha)(colours.interDark, 0.38)
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,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